import VinInput from './VinInput'

export default VinInput